export default __webpack_public_path__ + "static/robust_labs-ae15595d78db0b020c0a03d064dccb12.png";